import { RoutesMap } from '@Router/router.types';
import { CddEmbeddedFields } from '../../../../eddQuestions/pages/direct/field.types';
import { createUseCddLogic } from '../../../common/useCddLogic';
import type { CddDataFull, CddVolumeOptions } from '../../../common/api/cdd.api.types';
import type { CddVolumesFormValues } from '../../../common/formatCddDataToFormValues';

const formatCddDataToFormValues = (data: CddDataFull | undefined): CddVolumesFormValues => ({
  [CddEmbeddedFields.CDD_DOMESTIC_WIRE_VOLUMES_INCOMING]: data?.domesticWiresIncoming ?? '',
  [CddEmbeddedFields.CDD_DOMESTIC_WIRE_VOLUMES_OUTGOING]: data?.domesticWiresOutgoing ?? '',
});

export const useCddDomesticWireLogic = createUseCddLogic({
  schemaTitle: 'CddDomesticWireVolumes',
  route: RoutesMap.CDD_DOMESTIC_WIRE_VOLUMES,
  questionOneFieldName: CddEmbeddedFields.CDD_DOMESTIC_WIRE_VOLUMES_INCOMING,
  questionTwoFieldName: CddEmbeddedFields.CDD_DOMESTIC_WIRE_VOLUMES_OUTGOING,
  formatCddDataToFormValues,
  getPayload: (values) => ({
    domesticWiresIncoming: values[
      CddEmbeddedFields.CDD_DOMESTIC_WIRE_VOLUMES_INCOMING
    ] as CddVolumeOptions,
    domesticWiresOutgoing: values[
      CddEmbeddedFields.CDD_DOMESTIC_WIRE_VOLUMES_OUTGOING
    ] as CddVolumeOptions,
  }),
});
